import { render, staticRenderFns } from "./visualizarDadosUsuario.vue?vue&type=template&id=7c2c64ee&"
import script from "./visualizarDadosUsuario.vue?vue&type=script&lang=js&"
export * from "./visualizarDadosUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports